export default [
  {
    title: "Ana Sayfa",
    to: { name: "root" },
    icon: { icon: "tabler-smart-home" },
    yetki: { k: [] },
  },
  {
    title: "Kullanıcılar",
    to: { name: "kullanicilar" },
    icon: { icon: "tabler-users-group" },
    yetki: { k: [], a: true },
  },
  {
    title: "Etkinlik",
    to: { name: "etkinlik" },
    icon: { icon: "tabler-trekking" },
    yetki: { k: [1010002] },
  },
  {
    title: "Düğün/Etkinlik",
    to: { name: "dugun_etkinlik_tanitim" },
    icon: { icon: "wpf--wedding-cake" },
    yetki: { k: [], a: true },
  },
  {
    title: "Paket Tanıtım",
    to: { name: "paket_tanitim" },
    icon: { icon: "tabler-package" },
    yetki: { k: [], s: true },
  },
  {
    title: "Parametre",
    to: { name: "parametre" },
    icon: { icon: "tabler-settings" },
    yetki: { k: [], s: true },
  },
]
